import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { useAuth } from "../../../context/AuthContext";

import { useQuery } from "@tanstack/react-query";
import { fetchClients } from "../../../utils/helper";
import { ClientTypes } from "../../../utils/types";

export default function ClientCard() {
  const { jwt } = useAuth();
  
  const [atmCount, setAtmCount] = useState<number>(0);
  const [vendingCount, setVendingCount] = useState<number>(0);
  const [bnbCount, setBnbCount] = useState<number>(0);

  const { data: clients = [] } = useQuery({
    queryKey: ["clients"],
    queryFn: () => fetchClients(jwt),
  });

  useEffect(() => {
    setAtmCount(
      clients.filter((client) => client.type === ClientTypes.ATM).length
    );
    setVendingCount(
      clients.filter((client) => client.type === ClientTypes.VENDING).length
    );
    setBnbCount(
      clients.filter((client) => client.type === ClientTypes.AIRBNB).length
    );
  }, [clients]);

  return (
    <Card variant="outlined" sx={{ height: "100%", flexGrow: 1 }}>
      <CardContent>
        <Stack spacing={2}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography
              variant="subtitle2"
              sx={{
                borderBottom: "2px solid",
                borderColor: "success.main",
                flex: 1,
                textAlign: "center",
              }}
            >
              ATM
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                borderBottom: "2px solid",
                borderColor: "success.main",
                flex: 1,
                textAlign: "center",
              }}
            >
              Vending
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                borderBottom: "2px solid",
                borderColor: "success.main",
                flex: 1,
                textAlign: "center",
              }}
            >
              Bnb
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="h4"
              sx={{ flex: 1, textAlign: "center", fontWeight: "bold" }}
            >
              {atmCount}
            </Typography>
            <Typography
              variant="h4"
              sx={{ flex: 1, textAlign: "center", fontWeight: "bold" }}
            >
              {vendingCount}
            </Typography>
            <Typography
              variant="h4"
              sx={{ flex: 1, textAlign: "center", fontWeight: "bold" }}
            >
              {bnbCount}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
